// extracted by mini-css-extract-plugin
module.exports = {"Templates":"Templates___1aw1u","ModalTemplates":"ModalTemplates___3LFp8","Board":"Board___2oRHj","header":"header___jSES-","bodyTemplates":"bodyTemplates___3b-lH"};